import { render, staticRenderFns } from "./TodaysOfferResults.vue?vue&type=template&id=4136c1c4&scoped=true&"
import script from "./TodaysOfferResults.vue?vue&type=script&lang=js&"
export * from "./TodaysOfferResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4136c1c4",
  null
  
)

export default component.exports